import React from 'react';
import { toast, ToastContainer, ToastContentProps, ToastOptions } from 'react-toastify';
import { ErrorToast, InfoToast } from '@hz-design-system/web-ui';
import 'react-toastify/dist/ReactToastify.css';

import Classes from './ToastNotification.scss';

export const ToastContainerConfig = () => (
  <ToastContainer
    className={Classes.root}
    bodyClassName={Classes.body}
    closeButton={false}
    draggable={false}
    newestOnTop
    autoClose={false}
    closeOnClick={false}
    hideProgressBar
    position="bottom-center"
  />
);

type TToastNotificationProps = {
  type: string;
  description: string;
};

const ToastNotification = ({ type = 'info', description = '' }: TToastNotificationProps) => {
  const defaultOptions: ToastOptions = {
    className: Classes.message,
  };
  if (type === 'info') {
    toast(() => <InfoToast icon="info">{description}</InfoToast>, defaultOptions);
  }

  if (type === 'error') {
    toast(
      ({ closeToast }: ToastContentProps) => (
        <ErrorToast icon="alert" onClose={closeToast}>
          {description}
        </ErrorToast>
      ),
      defaultOptions,
    );
  }
};

export default ToastNotification;
